module.exports = __webpack_public_path__ + "static/media/YourStory.83ff5063.png";